export const TranslationMixin = (klass) => class extends klass {
  getTranslation(key, defaultValue){
    let value = undefined;
    if (this.props.translations){
      value = this.props.translations[key];
    }
    if (value === undefined){
      if (defaultValue !== undefined){
        value = defaultValue;
      } else {
        value = "!!" + key;
      }
    }
    return value
  }
}